<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="main2-list">
					<div class="main2-item" v-for="(item,index) in aptitudeList" :key="index">
						<div class="main2-pic">
							<div class="imgbox_a"><img :src="icoURL+'storage/'+item.image" alt=""></div>
						</div>
						<div class="main2-h1 tver">{{item.title}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'aptitude',
		data(){
			return{
				title:'',
				titleEn:'',
				aptitudeList:[],
			}
		},
		methods:{
			res_menuClass(e){
				this.axios.get('/api/menus/class?id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.title = response.data.reslut.name;
							this.titleEn = response.data.reslut.sub_title;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求资质展示
			res_aptitude(e){
				this.axios.get("/api/news/listNews?category_id="+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.aptitudeList = response.data.reslut;
							this.$nextTick(() => {
								$(".main2-list").liMarquee({
									drag: false,
									scrollamount: 100,
									direction: 'left',
									runshort: false
								});
							})
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
		},
		created(){
			this.res_menuClass(this.$route.query.category_id)
			// console.log(this.$route)
			this.res_aptitude(this.$route.query.category_id)
		},
		mounted(){

		}
	}
</script>

<style>
</style>